export function mapSynchroFTToEvent(synchro) {
  return {
    kind: "SYNCHRO_FT",
    id: `ft-${synchro.createdAt}-${synchro.categorie}-${synchro.type}`,
    date: synchro.createdAt,
    synchroFT: {
      categorie: synchro.categorie,
      type: synchro.type,
      statut: synchro.statut,
      data: synchro.data,
      updatedAt: synchro.updatedAt,
      tentatives: synchro.tentatives ?? [],
    },
  };
}

export function mergeAndSort(metierEvents, ftEvents) {
  const byId = new Map();
  [...metierEvents, ...ftEvents].forEach((e) => byId.set(e.id, e));
  return Array.from(byId.values()).sort(
    (a, b) => new Date(b.date) - new Date(a.date),
  );
}
